import type { DynamicChartFilter } from "../lib/pageFilterInteractions.js";

export function PageActiveFilterChips(props: {
  chips: DynamicChartFilter[];
  onRemove: (id: string) => void;
}) {
  const { chips, onRemove } = props;
  if (chips.length === 0) return null;
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
      {chips.map((chip) => (
        <span
          key={chip.id}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            border: "1px solid var(--color-border)",
            borderRadius: 999,
            padding: "4px 8px",
            background: "var(--color-surface-2)"
          }}
        >
          <span style={{ fontSize: 12 }}>{chip.label}</span>
          <button
            type="button"
            className="linkBtn"
            aria-label={`Remove filter ${chip.label}`}
            onClick={() => onRemove(chip.id)}
            style={{ lineHeight: 1, padding: 0 }}
          >
            x
          </button>
        </span>
      ))}
    </div>
  );
}
